
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.346 3.808h-1.96l1.641-1.641A1.269 1.269 0 1015.232.372l-3.807 3.807a1.269 1.269 0 000 1.795l3.807 3.808a1.27 1.27 0 001.795-1.795l-1.64-1.64h1.959a4.654 4.654 0 110 9.307 1.27 1.27 0 100 2.538c3.966 0 7.192-3.226 7.192-7.192s-3.226-7.192-7.192-7.192zM9.359 12.218a1.27 1.27 0 00-1.795 1.795l1.641 1.64H7.192a4.654 4.654 0 110-9.307 1.27 1.27 0 000-2.538C3.226 3.808 0 7.034 0 11s3.226 7.192 7.192 7.192h2.013l-1.641 1.641a1.27 1.27 0 101.795 1.795l3.808-3.808a1.27 1.27 0 000-1.795l-3.808-3.807z"}})])
          )
        }
      }
    